// core version + navigation, pagination modules:
import SwiperCore, { Navigation, Pagination, Autoplay, Lazy } from 'swiper';

// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination, Autoplay, Lazy]);

// add it to the window so it can be used in the theme
window.Swiper = SwiperCore;
